import React from 'react'

import AttachProduct from './components/attach_product'
import DetachProduct from './components/detach_product'
import UserPlansAndActiveSubs from './components/users_plans_and_active_subs'
import AttachBFSProduct from './components/attach_bfs_product'
import DetachBFSProduct from './components/detach_bfs_product'

const PlanTab = ({ userData, client, getUserInfo }) => {

  const userHasCustomProducts = userData.tags.includes('custom plans')

  return (
    <div className='plan-tab'>
      <div className='plan-tab-headers'>
        <AttachBFSProduct
          userData={userData}
          getUserInfo={getUserInfo}
          client={client}
        />
        <DetachBFSProduct
          userData={userData}
          getUserInfo={getUserInfo}
          client={client}
        />
        <AttachProduct
          userData={userData}
          getUserInfo={getUserInfo}
          client={client}
        />
        {
          userHasCustomProducts
            ? <DetachProduct
              userData={userData}
              getUserInfo={getUserInfo}
              client={client}
            />
            : null
        }
      </div>
      <div className='plan-tab__body'>
        <UserPlansAndActiveSubs
          client={client}
          userData={userData}
        />
      </div>
    </div>
  )
}

export default PlanTab
